export const getMetaContent = (name: string): string | undefined => {
  const metaElement = document.querySelector<HTMLMetaElement>(`meta[name=${name}]`);
  if (!metaElement) {
    return;
  }

  return metaElement.content;
};
